var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7339 4.02845C11.7279 2.26135 14.2721 2.26135 15.2661 4.02845L22.5205 16.9251C23.4954 18.6583 22.243 20.7998 20.2544 20.7998H5.74563C3.75708 20.7998 2.50463 18.6583 3.47953 16.9251L10.7339 4.02845ZM14.2999 16.9C14.2999 17.6179 13.7179 18.2 12.9999 18.2C12.2819 18.2 11.6999 17.6179 11.6999 16.9C11.6999 16.182 12.2819 15.6 12.9999 15.6C13.7179 15.6 14.2999 16.182 14.2999 16.9ZM12.9999 6.49998C12.2819 6.49998 11.6999 7.08201 11.6999 7.79997V11.7C11.6999 12.4179 12.2819 13 12.9999 13C13.7179 13 14.2999 12.4179 14.2999 11.7V7.79997C14.2999 7.08201 13.7179 6.49998 12.9999 6.49998Z",
    fill: "#E5A602"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningToastIcon);
export default __webpack_public_path__ + "static/media/WarningToastIcon.b5cade3493faae35c211b8e98a72e745.svg";
export { ForwardRef as ReactComponent };